import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { useCurrency } from '../context/CurrencyContext';

export const CurrencySwitcher = ({ className = '' }) => {
  const { currency, setCurrency, currencies } = useCurrency();
  return (
    <Select value={currency} onValueChange={setCurrency}>
      <SelectTrigger data-testid="currency-switcher" className={`h-9 w-24 border-gray-200 text-sm font-semibold ${className}`} aria-label="Currency">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {currencies.map((c) => <SelectItem key={c} value={c} data-testid={`currency-option-${c}`}>{c}</SelectItem>)}
      </SelectContent>
    </Select>
  );
};
